<template>
  <section class="form-section">
    <q-form ref="formContractData">
      <div class="col-12 row title-page-form">Dados do contrato</div>
      <div class="group-input q-mt-lg flex justify-between">
        <div class="col-4"
        >
          <label for="code_city">Cód. da Cidade</label>
          <q-select
            id="code_city"
            class="col-12 q-mt-sm full-width"
            placeholder="000"
            outlined
            dense
            v-model="contract.codeCity"
            color="red-9"
            @filter="filterCodCities"
            use-input
            hide-selected
            fill-input
            input-debounce="0"
            :options="optionsItensFiltered.optionsCodCity"
            @update:model-value="getCityByCodeCity()"
            option-value="value"
            option-label="value"
            bg-color="white"
            :rules="[(val) => !!val || 'Campo Obrigatório']"
            lazy-rules
          />
        </div>
        <div class='col-7'>
          <label for="contract_number">Nº do Contrato</label>
          <q-input
            class="col-4 q-mt-sm"
            id="contract_number"
            v-model="contract.contractNumber"
            placeholder="00000000"
            bg-color="white"
            color="red-9"
            maxlength="10"
            dense
            outlined
            :rules="[(val) => !!val || 'Campo Obrigatório']"
            lazy-rules
          />
        </div>
      </div>
      <div class="group-input q-mt-md">
        <label for="city">Cidade</label>
        <q-select
          id="city"
          class="q-mt-sm"
          outlined
          dense
          v-model="contract.city"
          color="red-9"
          use-input
          hide-selected
          fill-input
          input-debounce="0"
          :options="optionsItensFiltered.optionsCity"
          @filter="filterCities"
          option-value="value"
          option-label="text"
          bg-color="white"
          :rules="[(val) => !!val || 'Campo Obrigatório']"
          placeholder="Digite aqui"
          lazy-rules
        />
      </div>
    </q-form>
  </section>
</template>

<script>
import { computed, ref } from "vue";

export default {
  name: "ContractForm",
  props: {
    contract: Object,
    optionsItens: Object,
    typeOs: Number,
  },
  emits: ["update-city"],
  setup(props, {emit}) {
    let formContractData = ref(null);
    let optionsItensFiltered = ref({
      optionsCity:props.optionsItens.optionsCity,
      optionsCodCity: props.optionsItens.optionsCodCity,
    });

    function getCityByCodeCity() {
      props.contract.city = props.contract.codeCity;
      emit("update-city", props.contract.city);
    }

    async function validateForm() {
      return await formContractData.value.validate();
    }

    function filterCodCities(val, update) {
      update(() => {
        const needle = val.toLowerCase();
        optionsItensFiltered.value.optionsCodCity = props.optionsItens.optionsCodCity.filter(
          (v) => v.value.toLowerCase().indexOf(needle) > -1
        );
      });
    }

  function filterCities(val, update) {
    update(() => {
      if (val === "") {
        optionsItensFiltered.value.optionsCity = props.optionsItens.optionsCity;
        return;
      }
    });

    update(() => {
      const needle = val.toLowerCase();
      optionsItensFiltered.value.optionsCity = props.optionsItens.optionsCity.filter(
        (v) => v.text.toLowerCase().indexOf(needle) > -1
      );
    });
  }
    const getCity = computed(() => {
      return props.optionsItens.optionsCity;
    });

    const getCodCity = computed(() => {
       return props.optionsItens.optionsCodCity
    });

    return {
      formContractData,
      optionsItensFiltered,
      getCity,
      getCodCity,
      getCityByCodeCity,
      filterCodCities,
      filterCities,
      validateForm,
    };
  },
};
</script>

<style lang="scss" scoped>
.form-section {
  width: 100%;
  display: flex;
  flex-direction: column;
}

label {
  font-weight: bold;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.4);
}
</style>
